<template>
  <b-card no-body class="mt-6" v-if="tags.length">
    <EditTag />
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-colorblue"
      :data="tags"
      border
    >
      <!-- <el-table-column label="Sr no." prop="srno" min-width="90px" sortable >

      </el-table-column> -->
      <el-table-column label="Name" min-width="150px" sortable>
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Page" min-width="150px" sortable>
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row.filter.categoryPage.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Filter Name" min-width="150px" sortable>
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.filter.name }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Edited By" min-width="150px" sortable>
        <template v-slot="{ row }">
          <p
            class="font-semibold text-left name mb-0 text-sm"
            v-if="row.isEdited"
          >
            {{
              row.editedBy.at(-1)._user.firstname +
                " " +
                row.editedBy.at(-1)._user.lastname || " "
            }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="40px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        @change="handlePageChange"
        :per-page="perPage"
        :total="totalPages"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import TagsData from "./TagsData";
import tagMixin from "../mixins/tagMixin";
import { mapState } from "vuex";
import EditTag from "./EditTagsDetail.vue";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  mixins: [tagMixin],
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTag,
  },
  computed: {
    ...mapState("cmstag", {
      tags: "tags",
      pageCategories: "pageCategories",
    }),
    displayedPages() {
      return this.tags;
      //   .slice(
      //   (this.currentPage - 1) * this.perPage,
      //   this.currentPage * this.perPage
      // );
    },
    // totalPages() {
    //   return this.tags.length;
    // },
  },
  data() {
    return {
      TagsData,
      userToggle: false,
      currentPage: 1,
      post: [],
      perPage: 5,
      totalPages: 0,
      name: "",
    };
  },
  methods: {
    handlePageChange(value) {
      this.currentPage = value;
      try {
        this.init();
      } catch (error) {}
    },

    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },

    async init() {
      await this.$store.dispatch("cms/getListings");

      let payload = {
        offset: (this.currentPage - 1) * 5,
        limit: 5,
      };
      let tags = await this.$store.dispatch("cmstag/getTags", payload);
      // const params = new URLSearchParams();
      // params.append(
      //   "filter",
      //   JSON.stringify({
      //     listing: this.listings[0]._id,
      //   })
      // );
      this.totalPages = tags.data.countDoc;
      await this.$store.dispatch("cms/getPageCategories");

      this.pageCategories.forEach((element) => {
        if (element.route.includes("self-help-tools")) {
          // console.log(element);
          this.categoryId = element._id;
          this.categoryName = element.name;
        }
      });

      const { data } = await this.$store.dispatch("cms/getpagebycategory", {
        id: this.categoryId,
      });
      // console.log(data);
    },

    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },

    async deleteData({ row }) {
      const payload = {
        tagid: row._id,
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("cmstag/deleteTag", payload);
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async handleEdit(scope) {
      let { row } = scope;
      this.$store.commit("UI/TOGGLE_CHANNEL_CREATE_SIDEBAR", true);
      await this.$store.commit("cmstag/SET_SELECT_TAG", row);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
